import { combineReducers } from 'redux';

import pantry from './pantry';
import user from './user';
import smtpAccount from './smtp-account';

export default combineReducers({
  pantry,
  user,
  smtpAccount
});
